import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatSidenav, MatSidenavContent } from '@angular/material/sidenav';
import { CoreService } from 'src/app/services/core.service';
import { AppSettings } from 'src/app/app.config';
import { filter } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { navItems, navItemsClient } from './vertical/sidebar/sidebar-data';
import { AppNavItemComponent } from './vertical/sidebar/nav-item/nav-item.component';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './vertical/sidebar/sidebar.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { TablerIconsModule } from 'angular-tabler-icons';
import { HeaderComponent } from './vertical/header/header.component';
import { AppHorizontalHeaderComponent } from './horizontal/header/header.component';
import { AppHorizontalSidebarComponent } from './horizontal/sidebar/sidebar.component';
import { CustomizerComponent } from './shared/customizer/customizer.component';
import { AuthService } from 'src/app/pages/authentication/service/auth.service';
import { NavItem } from './vertical/sidebar/nav-item/nav-item';
import { PushNotificationService } from 'src/app/services/push-notification.service';

const MOBILE_VIEW = 'screen and (max-width: 768px)';
const TABLET_VIEW = 'screen and (min-width: 769px) and (max-width: 1024px)';
const MONITOR_VIEW = 'screen and (min-width: 1024px)';
const BELOWMONITOR = 'screen and (max-width: 1023px)';

// for mobile app sidebar
interface apps {
  id: number;
  img: string;
  title: string;
  subtitle: string;
  link: string;
}

interface quicklinks {
  id: number;
  title: string;
  link: string;
}

@Component({
  selector: 'app-full',
  standalone: true,
  imports: [
    RouterModule,
    AppNavItemComponent,
    MaterialModule,
    CommonModule,
    SidebarComponent,
    NgScrollbarModule,
    TablerIconsModule,
    HeaderComponent,
    AppHorizontalHeaderComponent,
    AppHorizontalSidebarComponent,
    CustomizerComponent,
  ],
  templateUrl: './full.component.html',
  styleUrls: ['../../.././styles.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FullComponent implements OnInit {
  navItems = navItems;
  navItemsClient = navItemsClient;
  public navItemsMostrar: any;
  public tokenSession = localStorage.getItem('token');
  @ViewChild('leftsidenav') public sidenav: MatSidenav;
  @ViewChild('content', { static: true }) content!: MatSidenavContent;
  public resView = false;
  //get options from service
  public options = this.settings.getOptions();
  private layoutChangesSubscription = Subscription.EMPTY;
  public isMobileScreen = false;
  private isContentWidthFixed = true;
  private isCollapsedWidthFixed = false;
  public name: string;
  public roles: Array<string>;
  public permissions: Array<string>;
  public isClient: string;
  private htmlElement!: HTMLHtmlElement;

  get isOver(): boolean {
    return this.isMobileScreen;
  }

  get isTablet(): boolean {
    return this.resView;
  }

  // for mobile app sidebar
  apps: apps[] = [
  
  ];

  quicklinks: quicklinks[] = [
  ];

  constructor(
    private settings: CoreService,
    private router: Router,
    private breakpointObserver: BreakpointObserver,
    private authService: AuthService,
    private pushNotificationService: PushNotificationService
  ) {
    const token = sessionStorage.getItem('id_token_claims_obj');
    //const token = localStorage.getItem('token');

    if (!token) {
      this.name = this.authService.getNameIdentifier();
      this.isClient = this.authService.getUserType();
      if(this.isClient=="True") {
        this.navItemsMostrar = this.navItemsClient;
      }
      else {
        this.navItemsMostrar = this.navItems;
      }
    } else {
      const { given_name, family_name } = JSON.parse(token);
      this.name = `${given_name} ${family_name}`;
      this.navItemsMostrar = this.navItems;
    }

    this.roles = this.authService.getUserRoles();
    this.permissions = this.authService.getUserPermissions();
    this.htmlElement = document.querySelector('html')!;
    this.layoutChangesSubscription = this.breakpointObserver
      .observe([MOBILE_VIEW, TABLET_VIEW, MONITOR_VIEW, BELOWMONITOR])
      .subscribe((state) => {
        // SidenavOpened must be reset true when layout changes
        this.options.sidenavOpened = true;
        this.isMobileScreen = state.breakpoints[MOBILE_VIEW];
        if (this.options.sidenavCollapsed == false) {
          this.options.sidenavCollapsed = state.breakpoints[TABLET_VIEW];
        }
        this.isContentWidthFixed = state.breakpoints[MONITOR_VIEW];
        this.resView = state.breakpoints[BELOWMONITOR];
      });

    // Initialize project theme with options
    this.receiveOptions(this.options);

    // This is for scroll to top
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((e) => {
        this.content.scrollTo({ top: 0 });
    });
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    this.layoutChangesSubscription.unsubscribe();
  }

  toggleCollapsed() {
    this.isContentWidthFixed = false;
    this.options.sidenavCollapsed = !this.options.sidenavCollapsed;
    this.resetCollapsedState();
  }

  resetCollapsedState(timer = 400) {
    setTimeout(() => this.settings.setOptions(this.options), timer);
  }

  onSidenavClosedStart() {
    this.isContentWidthFixed = false;
  }

  onSidenavOpenedChange(isOpened: boolean) {
    this.isCollapsedWidthFixed = !this.isOver;
    this.options.sidenavOpened = isOpened;
    this.settings.setOptions(this.options);
  }

  receiveOptions(options: AppSettings): void {
    this.options = options;
    this.toggleDarkTheme(options);
  }

  toggleDarkTheme(options: AppSettings) {
    if (options.theme === 'dark') {
      this.htmlElement.classList.add('dark-theme');
      this.htmlElement.classList.remove('light-theme');
    } else {
      this.htmlElement.classList.remove('dark-theme');
      this.htmlElement.classList.add('light-theme');
    }
  }

  onLogout() {
    this.router.navigateByUrl('/login');
    localStorage.removeItem('token');
    this.pushNotificationService.unsuscribeToPush();
    sessionStorage.clear();
  }

  public displaySidenavOption(navItem: NavItem): boolean{
    if(navItem == undefined) return false;
    if(navItem.permissions === undefined || navItem?.permissions?.length == 0 ) return true;
    const hasPermission: boolean = navItem?.permissions?.some(r => this.permissions.includes(r));
    return hasPermission;
  }

  probando() {
    this.sidenav.toggle()
  }

  public redirectInfoUser() {
    if(this.isClient=='True') {
      this.router.navigateByUrl('dashboards/cliente/meInfo');
    }
    else {
      return;
    }
  }

}